import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { ICON_SIZE_OPTIONS } from '../../utils/constants';
import { transformIconProps } from '../../utils/icons';
var IconUiCloseFilled = function IconUiCloseFilled(_ref) {
  var fillColor = _ref.fillColor,
    strokeColor = _ref.strokeColor,
    props = _objectWithoutProperties(_ref, ["fillColor", "strokeColor"]);
  return jsx("svg", _extends({
    width: "16",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, transformIconProps(props)), jsx("path", {
    d: "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8z",
    fill: fillColor || '#fff'
  }), jsx("path", {
    d: "m3.333 3.333 9.334 9.334M12.667 3.333l-9.334 9.334",
    stroke: strokeColor || 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { IconUiCloseFilled };